<template>
  <span class="emd-security-tag">
    <i class="uil uil-shield-check"></i>
    <span>{{ $t('footer.security') }}</span>
  </span>
</template>
<script>
export default {
  name: 'EmdSecurityTag'
}
</script>

<style>
.emd-security-tag {
  margin: 0 8px;
}
.emd-security-tag span {
  margin-left: 8px;
}
</style>
